import React from "react"
import classnames from "classnames"
import debounce from 'debounce'
import { StickySection, ButtonIcon } from "AtomicComponents"
import { Tabs } from "AtomicContainers"
import { WINDOW, IS_IE } from "AtomicUtils/environment"
import gtmHandler from "AtomicUtils/gtmHandler"
import componentParser from "AtomicUtils/componentParser"
import urlHandler from "AtomicUtils/urlHandler"
import { scrollToElementId } from "AtomicUtils/scroll"
import styles from "./StickyNav.less"

class StickyNav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      height: 60,
      pageOffset: 0,
      activeIndex: 0,
      isIE: false,
    }
  }

  componentDidMount() {
    if (this.stickyNav) {
      this.setState({
        height: this.stickyNav.clientHeight
      })
    }

    WINDOW.addEventListener("scroll", debounce(this.checkPageOffset, 250), {
      passive: true
    })

    WINDOW.addEventListener("hashchange", debounce(this.scrollToHash, 400), {
      passive: true
    })

    setTimeout(this.checkPageOffset, 0);
    setTimeout(()=>{
      this.setState({
        isIE: IS_IE
      })
    }, 0)

    WINDOW.addEventListener(
      "UPDATE_STICKY_NAV",
      () => this.checkPageOffset(),
      false
    )
  }

  componentWillUnmount() {
    WINDOW.removeEventListener("scroll", debounce(this.checkPageOffset, 250), {
      passive: true
    })

    WINDOW.removeEventListener("hashchange", debounce(this.scrollToHash, 250), {
      passive: true
    })
  }

  scrollToHash = () => {
    const { activeHash } = this.state
    const hash = new urlHandler(WINDOW.location.href).getHash()
    if (hash && activeHash !== hash) scrollToElementId(hash)
  }

  checkPageOffset = () => {
    if (WINDOW && WINDOW.stickyBar){
      const { items } = this.props
      const { height } = this.state
      const pageOffset = WINDOW.pageYOffset
      this.setState({ pageOffset })

      items && items.map((item, index) => {
        const element = WINDOW.document.querySelector(`[data-name="${item.slug}"]`)

        if (element) {
          const elementOffset = element.offsetTop

          if ((elementOffset <= (pageOffset + height)) && ((elementOffset + element.clientHeight) > (pageOffset + height + 50))) {
            new urlHandler(WINDOW.location.href).setHash(item.slug)
            this.setState({ activeIndex: index, activeHash: item.slug })
          }
        }
      })

      return pageYOffset
    }
  }

  handleClick = (index) => {
    const { items, gtm } = this.props

    // Delay for firing GTM before redirection
    // Call GTM if we have an gtm object
    if (gtm && gtm.category && gtm.action && gtm.category !== "" && gtm.action !== "") {
      gtmHandler({
        pageCategory: gtm.category,
        pageAction: gtm.action + ` - "${items[index].name.toUpperCase()}"`
      })
    }

    scrollToElementId(items[index].slug)
  }

  _handleClickOnLogo = () => {
    scrollToElementId('header')
  }

  render() {
    const {
      logo, imageAlt, items, components
    } = this.props
    const { activeIndex, isIE } = this.state

    return (
      <StickySection alwaysOnTop>
        <div
          ref={c => (this.stickyNav = c)}
          id="sticky-nav"
        className={classnames({
            [styles.StickyNav]: true
          })}>
          {
            logo &&
            <div className={classnames({
              [styles.StickyNavImage]: true,
              [styles.StickyNavImageIE]: isIE
            })}>
              <ButtonIcon
                onClick={this._handleClickOnLogo}
              >
                <img
                  src={logo}
                  alt={imageAlt}
                  height="25"
                />
              </ButtonIcon>
            </div>
          }
          {
            items &&
            <div className={classnames({
              [styles.StickyNavItems]: true
            })}>
              <Tabs
                options={items}
                scrolling
                activeLineOnly
                onClick={this.handleClick}
                activeIndex={activeIndex}
              />
            </div>
          }
          {
            components &&
            <div className={classnames({
              [styles.StickyNavButton]: true
            })}>
              {componentParser(components)}
            </div>
          }
        </div>
      </StickySection>
    )
  }
}

export default StickyNav



// WEBPACK FOOTER //
// ./src/AtomicContainers/StickyNav/StickyNav.jsx